var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{staticClass:"flex items-center justify-center",style:(_vm.gradient)},[(_vm.displayTime && _vm.current > 0)?_c('span',{staticClass:"text-lg text-white"},[_vm._v(_vm._s(_vm.current.toFixed(1)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }